import React from 'react';
import './styles.css';
import Nav from 'react-bootstrap/Nav'

class Menu extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div style={{background:'#cccccc', paddingTop:'30px'}}>
                <Nav className={'justify-content-end'} variant={'tabs'}
                     defaultActiveKey={this.props.selectedTab}>
                    <Nav.Item><Nav.Link href={'/'}>Home</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link href={'/projects'}>My Projects</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link href={'/news'}>News</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link href={'/about'}>About</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link href={'/expensesSplit'}>Expenses Split</Nav.Link></Nav.Item>
                </Nav>
            </div>
        );
    }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/screens/menu/index.js